import { render, staticRenderFns } from "./MechanicReport.vue?vue&type=template&id=9c6a9456&scoped=true&"
import script from "./MechanicReport.vue?vue&type=script&lang=ts&"
export * from "./MechanicReport.vue?vue&type=script&lang=ts&"
import style0 from "./MechanicReport.vue?vue&type=style&index=0&id=9c6a9456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6a9456",
  null
  
)

export default component.exports